import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

export interface SharedFile {
  fileId: string;
  fileName: string;
  fileType?: string;
  fileSize?: number;
  uploadDate?: Date;
  sharedDate?: Date;
}

export interface SharedFilesDialogData {
  userName: string;
  userEmail: string;
  files: SharedFile[];
  casename: string;
}

@Component({
    selector: 'app-shared-files-dialog',
    templateUrl: './shared-files-dialog.component.html',
    styleUrls: ['./shared-files-dialog.component.scss'],
    standalone: false
})
export class SharedFilesDialogComponent {
  loading = false;
  refreshing = false;

  constructor(
    public dialogRef: MatDialogRef<SharedFilesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SharedFilesDialogData,
    private snackBar: MatSnackBar
  ) {}

  onUnshareAll() {
    this.dialogRef.close({ action: 'unshareAll' });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  async onRefreshData(): Promise<void> {
    if (this.refreshing) return;

    try {
      this.refreshing = true;
      // Here you could implement actual refresh logic
      this.snackBar.open('File list refreshed', 'Close', {
        duration: 2000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } catch (error) {
      console.error('Error refreshing data:', error);
      this.snackBar.open('Failed to refresh data', 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom'
      });
    } finally {
      this.refreshing = false;
    }
  }

  getFileIcon(fileType: string): string {
    if (fileType) {
      const type = fileType.toLowerCase();
      if (type.includes('pdf')) return 'picture_as_pdf';
      if (type.includes('image') || type.includes('jpg') || type.includes('png') || type.includes('gif'))
        return 'image';
      if (type.includes('video')) return 'video_file';
      if (type.includes('audio')) return 'audio_file';
      if (type.includes('word') || type.includes('doc')) return 'description';
      if (type.includes('excel') || type.includes('xls')) return 'table_chart';
      if (type.includes('powerpoint') || type.includes('ppt')) return 'slideshow';
    }
    return 'insert_drive_file';
  }

  getFileTypeClass(fileType: string): string {
    if (fileType) {
      const type = fileType.toLowerCase();
      if (type.includes('pdf')) return 'pdf';
      if (type.includes('image') || type.includes('jpg') || type.includes('png') || type.includes('gif'))
        return 'image';
      if (type.includes('video')) return 'video';
      if (type.includes('audio')) return 'audio';
      if (type.includes('word') || type.includes('doc')) return 'document';
      if (type.includes('excel') || type.includes('xls')) return 'spreadsheet';
      if (type.includes('powerpoint') || type.includes('ppt')) return 'presentation';
    }
    return 'file';
  }

  getFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }

  // TrackBy function for better performance
  trackByFile(index: number, file: SharedFile): string {
    return file.fileId || index.toString();
  }
}
